<template>
  <div class="wait-for-previous">
    <md-checkbox
      :value="value"
      :disabled="disabled"
      class="md-primary"
      @change="(checked) => $emit('change', !!checked)"
    >
      Wait for previous dialogue to finish
    </md-checkbox>
    <help-tooltip>
      Automatically prepends a timer so the previous dialogue<br>for this character finishes playing before this node runs.<br>Only allowed when Unsolicited dialogue by the<br>same character immediately precedes this effect. 
    </help-tooltip>
  </div>
</template>

<script>
import HelpTooltip from '~lib/common/components/HelpTooltip';

export default {
  name: 'wait-for-previous-checkbox',
  components: {
    HelpTooltip,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
/* White card like the selects above; a bare label is unreadable on the node's fill. */
.wait-for-previous {
  margin-top: 5px;
  display: flex;
  align-items: center;
  padding: 8px 10px;
  background-color: white;
  border-radius: 4px;
}

.wait-for-previous >>> .md-checkbox {
  margin: 0;
  min-height: auto;
}

/* The default label is sized for a standalone field and clips at node width. */
.wait-for-previous >>> .md-checkbox .md-checkbox-label {
  font-size: 13px;
  line-height: 1.35;
  height: auto;
  padding-left: 8px;
  padding-top: 1px;
  color: black;
  white-space: normal;
}

/* The label color above would otherwise survive into the disabled state. */
.wait-for-previous >>> .md-checkbox.md-disabled .md-checkbox-label {
  color: rgba(0, 0, 0, 0.38);
}

.wait-for-previous >>> .help-tooltip {
  margin-left: 6px;
}
</style>
